import webui from "@tinqin/tinqin-web-ui";
import DateUtils from "@tinqin/tinqin-utils/src/date";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import t from "../../common/utils/translation/Translate";

//returns "dayNumber monthName yyyy HH:MM" format
function formatSpecial(input) {
    const date = new Date(input);
    const year = date.getFullYear().toString();
    const day = date.getDate();
    const locale = webui.getGlobalProperty("locale");
    const monthLong = new Intl.DateTimeFormat(locale, { month: "long" }).format(date);
    return day + " " + monthLong + " " + year;
}

//component for outputing Article event dates, no additional markup
//returns "dayNumber monthName yyyy HH:MM" format
function OutputEventDate(props) {
    const data = props.data ? props.data.properties || {} : null;
    if (!data) {
        return "";
    }

    let result;
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["value", "format"]
    });
    if (dataProps.value) {
        if (!dataProps.format) {
            result = formatSpecial(dataProps.value);
        } else {
            result = DateUtils.simpleFormat(dataProps.value, dataProps.format);
        }
    } else {
        const dataEntity = EntityBuilder.of(props.data, { inplace: true });
        let from = dataEntity.getChild("start").getValue();
        let to = dataEntity.getChild("end").getValue();
        from = from ? formatSpecial(from) : "";
        to = to ? formatSpecial(to) : "";
        result = `${t("on")} ${from}`;
        if (from !== to) {
            //http://jira.tinqin.com/browse/UGP-2057
            result = `${t("from")} ${from} ${t("to")} ${to}`;
        }
    }

    return result;
}

export default webui.connectComponent()(OutputEventDate);
